import {
  BooleanField,
  Datagrid,
  DateField,
  FilterButton,
  List,
  NumberField,
  NumberInput,
  SelectInput,
  TextField,
  TopToolbar,
  ExportButton,
} from 'react-admin';

const feedbackFilters = [
  <NumberInput key="rating" source="rating" label="Rating" alwaysOn />,
  <SelectInput
    key="would_visit_again"
    source="would_visit_again"
    label="Would Visit Again"
    choices={[
      { id: 'yes', name: 'Yes' },
      { id: 'maybe', name: 'Maybe' },
      { id: 'no', name: 'No' },
    ]}
  />,
  <SelectInput
    key="flagged"
    source="flagged"
    label="Flagged"
    choices={[
      { id: 'true', name: 'Flagged' },
      { id: 'false', name: 'Not Flagged' },
    ]}
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <ExportButton />
  </TopToolbar>
);

export function FeedbackList() {
  return (
    <List
      filters={feedbackFilters}
      actions={<ListActions />}
      sort={{ field: 'created_at', order: 'DESC' }}
    >
      <Datagrid>
        <TextField source="business_id" label="Business ID" />
        <NumberField source="rating" />
        <TextField source="would_visit_again" label="Visit Again" />
        <TextField source="improvement_text" label="Feedback" />
        <BooleanField source="is_flagged" label="Flagged" />
        <DateField source="created_at" showTime />
      </Datagrid>
    </List>
  );
}
